const CHINESE_REALM_PREFIX = 'cn'

export function isChineseRealm(realm) {
    return realm.toLowerCase().startsWith(CHINESE_REALM_PREFIX)
}



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/helpers/realm.js